import { TransferOfChargeConstant } from "presentation/constant/TransferOfCharge/TransferOfChargeConstant";
import { useTransferOfChargeVM } from "presentation/hook/TransferOfCharge/useTransferOfChargeVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useTransferOfChargeTracked } from "presentation/store/TransferOfCharge/TransferOfChargeProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DatePickerComponent from "presentation/view/components/DatePickerComponent";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { memo, useCallback, useMemo, useState } from "react";
import { FieldType, HPHButton, IconButton, IFieldValue, Loader } from "veronica-ui-component/dist/component/core";
import { SidebarActionBar, SidebarActionCross, Sidebarheader, SidebarTitle } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";


const TransferOfChargeEditPanel = () => {
    const SCREEN_CONSTANT = TransferOfChargeConstant;
    const [transferOfChargeState] = useTransferOfChargeTracked();
    const transferOfChargeVM = useTransferOfChargeVM();
    const messageBarVM = useMessageBarVM();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { buikEditCriteria, searchCriteria, isUptExciseCashNo, isUptPaidThroughDate, isEditClick, isUptBillTo, isUptChargeOn, isUpdateAccTmlReasonCode } = transferOfChargeState;
    const [anaInfoState] = useANAInfoTracked();
    const { operatingUnit } = anaInfoState;

    const saveButtonClicked = useCallback(async () => {
        if (!buikEditCriteria.billToCompany && !buikEditCriteria.chargeOnCompany
            && !buikEditCriteria.exciseCashNo && !buikEditCriteria.paidThroughDate && !buikEditCriteria.accTmlReasonCode) {
            messageBarVM.showError("Please input one of them at least.");
            return;
        }
        setIsLoading(true);
        await transferOfChargeVM.onSave(buikEditCriteria).then(data => {
            if (data && data.success) {
                transferOfChargeVM.onSearch(searchCriteria).then((data) => {
                    messageBarVM.showSuccess("Save Successfully.");
                    setIsLoading(false)
                }).catch(error => {
                    setIsLoading(false)
                });
            } else {
                setIsLoading(false)
                messageBarVM.showError(data.data);
                return;
            }
        });
    }, [buikEditCriteria, messageBarVM, searchCriteria, transferOfChargeVM]);

    const closeButtonClicked = async () => {
        transferOfChargeVM.onCloseEidtPanel();
    }

    const memoPaidThroughDate = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "24px" }}>
            <DatePickerComponent
                disabled={false}
                label={SCREEN_CONSTANT.PAID_THROUGH_DATE}
                width="220px"
                date={buikEditCriteria?.paidThroughDate}
                fieldName="paidThroughDate"
                errorMessage={''}
                onDateChange={transferOfChargeVM.onEditFieldChange} />
        </div>
        , [SCREEN_CONSTANT.PAID_THROUGH_DATE, buikEditCriteria?.paidThroughDate, transferOfChargeVM.onEditFieldChange])


    const memoChargeOnCompany = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={buikEditCriteria?.chargeOnCompany || ''}
                fieldValue={buikEditCriteria?.chargeOnCompany}
                fieldLabel={SCREEN_CONSTANT.CHARGEON_COMPANY}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'chargeOnCompany'}
                maxLength={60}
                sort={false}
                isLimitOptions={true}
                options={transferOfChargeState.dynamicOptions.chargeOnCompanyDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    transferOfChargeVM.onEditFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [buikEditCriteria?.chargeOnCompany, SCREEN_CONSTANT.CHARGEON_COMPANY, transferOfChargeState.dynamicOptions.chargeOnCompanyDropdownOptions, transferOfChargeVM])

    const memoBillToCompany = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={buikEditCriteria?.billToCompany || ''}
                fieldValue={buikEditCriteria?.billToCompany}
                fieldLabel={SCREEN_CONSTANT.BILLTO_COMPANY}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'billToCompany'}
                maxLength={60}
                sort={false}
                isLimitOptions={true}
                options={transferOfChargeState.dynamicOptions.billToCompanyDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    transferOfChargeVM.onEditFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [buikEditCriteria?.billToCompany, SCREEN_CONSTANT.BILLTO_COMPANY, transferOfChargeState.dynamicOptions.billToCompanyDropdownOptions, transferOfChargeVM])


    const memoExciseCashNo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={buikEditCriteria?.exciseCashNo ?? ''}
                fieldValue={buikEditCriteria?.exciseCashNo}
                fieldLabel={SCREEN_CONSTANT.EXCISE_CASH_NO}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'exciseCashNo'}
                maxLength={60}
                //isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    transferOfChargeVM.onEditFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [buikEditCriteria?.exciseCashNo, SCREEN_CONSTANT.EXCISE_CASH_NO, transferOfChargeVM])


    const memoReasonCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={buikEditCriteria?.accTmlReasonCode ?? ''}
                fieldValue={buikEditCriteria?.accTmlReasonCode}
                fieldLabel={SCREEN_CONSTANT.REASON_CODE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'accTmlReasonCode'}
                maxLength={60}
                //isTextFieldCapitalize={true}
                options={transferOfChargeState.dynamicOptions.reasonCodeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    transferOfChargeVM.onEditFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [buikEditCriteria?.accTmlReasonCode, SCREEN_CONSTANT.REASON_CODE, transferOfChargeState.dynamicOptions.reasonCodeDropdownOptions, transferOfChargeVM])

    return (
        <div className='side-form-content-wrapper'>
            <div className={'flex-row'}>
                <div className={'flex-row-item flex-row-item-full-width'}>
                    <Sidebarheader>
                        <SidebarTitle>
                            {TransferOfChargeConstant.BULK_EDIT}
                        </SidebarTitle>
                        <SidebarActionCross>
                            <IconButton
                                fileName="Icon-cross" size="medium" toolTipText='Close' toolTipArrow={false} onClick={closeButtonClicked} />
                        </SidebarActionCross>
                    </Sidebarheader>
                </div>
            </div>
            {isLoading &&
                <Loader Indicator="Spinner" size="Medium" />}
            {!isLoading && <>
                <div className={'add-edit-form'} style={{ height: '75vh', maxHeight: '75vh', overflow: 'auto' }}>
                    <div className="flex-row-auto">
                        <div className={'flex-row-item'}>
                            <CriteriaItemContainer>
                                {(isEditClick || isUptBillTo) && memoBillToCompany}
                            </CriteriaItemContainer>
                            <CriteriaItemContainer>
                                {(isEditClick || isUptChargeOn) && memoChargeOnCompany}
                            </CriteriaItemContainer>
                            <CriteriaItemContainer>
                                {isUptPaidThroughDate && memoPaidThroughDate}
                            </CriteriaItemContainer>
                            {
                                operatingUnit !== 'AQCT' && operatingUnit !== 'RSCT' &&

                                <CriteriaItemContainer>
                                    {isUptExciseCashNo && memoExciseCashNo}
                                </CriteriaItemContainer>
                            }


                            <CriteriaItemContainer>
                                {isUpdateAccTmlReasonCode && memoReasonCode}
                            </CriteriaItemContainer>
                        </div>
                    </div>
                </div>
                <SidebarActionBar>
                    <HPHButton label={'Close'} size={'Small'} theme={'Secondary'} onClick={closeButtonClicked} />
                    <HPHButton label={'Save'} size={'Small'} theme={'Primary'} onClick={saveButtonClicked} />
                </SidebarActionBar>
            </>}
        </div>
    );
}

export default memo(TransferOfChargeEditPanel);